export enum BlockType {
  GenericUserBlock = 1,
  SelfExclusionUserBlock = 2,
  TimeoutUserBlock = 4,
  ResponsibleUserBlock = 6,
  All = 7,
}
